import { FieldError, UseFormRegister } from 'react-hook-form';
import { ErrorBox } from './ErrorBox';

type ToSFormCheckboxProps = {
  errors: FieldError | undefined;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  register: UseFormRegister<any>;
};

export function ToSFormCheckbox(props: ToSFormCheckboxProps) {
  const { register, errors } = props;

  return (
    <div className='flex flex-col gap-4 font-medium text-sm text-gray-700'>
      <div className='flex flex-row gap-2 h-15 items-start'>
        <input
          type='checkbox'
          {...register('termsOfService', {
            required: { value: true, message: 'To continue, agree to the terms of use.' },
          })}
          className='mt-1'
        />
        <ToSLabel />
      </div>
      {errors && <ErrorBox>{errors.message}</ErrorBox>}
    </div>
  );
}

type ToSCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
};

export const ToSCheckbox = ({ error, checked, onChange }: ToSCheckboxProps) => {
  return (
    <div className='flex flex-col gap-4 font-medium text-sm text-gray-700'>
      <div className='flex flex-row gap-2 h-15 items-start'>
        <input
          type='checkbox'
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className='mt-1'
        />
        <ToSLabel />
      </div>
      {error && <ErrorBox>{error}</ErrorBox>}
    </div>
  );
};

const ToSLabel = () => {
  return (
    <label>
      I agree to the MovingWorlds{' '}
      <a className='underline text-brand-100' href='https://movingworlds.org/terms-of-use'>
        Terms of Use
      </a>{' '}
      and to receive occasional news and updates. I can unsubscribe at any time.
    </label>
  );
};
